<template>
  <div id="adminTemplateEditor">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">{{ setting }}</li>
      <li class="breadcrumb-item active">
        <router-link
          :to="url"
          v-on:click.native="executeCancelNewTemplateEditor"
        >{{ templateEditor }}</router-link>
      </li>
    </ol>
     <div class="container-fluid card-title-admin">
        <h1>{{ templateEditor }}</h1>
    </div>
    <div class="container-fluid">
      <div class="card">
        <div class="tab-content noborder">
          <div class="tab-pane active" id="tabTemplateEditorTable" role="tabpanel">
            <div class="row align-btns">
              <div class="col-lg-12">
                <button
                  id="btnAdd"
                  type="button"
                  class="btn btn-primary"
                  @click="onNewTemplateEditor"
                >
                  <i class="fa fa-plus"></i>
                  <span>{{ add }}</span>
                </button>
                <button
                  id="btnSave"
                  type="button"
                  class="btn btn-success"
                  @click="confirmSaveTemplateEditor"
                  :disabled="disableButton"
                >
                  <i class="fa fa-floppy-o"></i>
                  <span>{{ save }}</span>
                </button>
                <button
                  id="btnDelete"
                  type="button"
                  class="btn btn-danger"
                  @click="confirmDeleteTemplateEditor"
                  :disabled="disableButton"
                >
                  <i class="fa fa-trash"></i>
                  <span>{{ del }}</span>
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <bootstrapTable
                  :configurations="tableTemplateEditorConfiguration"
                  :datas="tableTemplateEditorData"
                  id="tableTemplateEditor"
                  :onCheck="onTableCheckTemplateEditor"
                  :onCheckAll="onTableCheckTemplateEditor"
                  :onUncheck="onTableCheckTemplateEditor"
                  :onUncheckAll="onTableCheckTemplateEditor"
                  ref="tableTemplateEditor"
                  :results="tableTemplateEditorResult"
                ></bootstrapTable>
              </div>
            </div>
          </div>
          <div class="tab-pane nopadding" id="tabTemplateEditorDetail" role="tabpanel">
                  <div class="card-body" style="padding:30px;">
              <div class="row">
               <div v-if="rowIdSelected > 0">
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Modifica</h1>
                      </div>
                      <div v-else>
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Aggiungi</h1>
                      </div>
                <pageDetail
                  functions="AdminSettingTemplateEditor"
                  :configurations="detailTemplateEditorConfiguration"
                  :jsonValue="detailTemplateEditorData"
                ></pageDetail>
                <div style="margin-top:30px;width:100%;">
                <FroalaEditor
                  :content="detailTemplateEditorData.html"
                  v-on:updateContenuto="updateContenuto"
                  :tipoTemplate="tipoTemplate"
                ></FroalaEditor>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-right">
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="confirmCancelNewTemplateEditor"
                  ><i class="fa fa-times"></i>&nbsp; {{ cancel }}</button>
                  <button
                    type="button"
                    class="btn btn-success"
                    @click="confirmSaveNewTemplateEditor"
                  ><i class="fa fa-floppy-o"></i>&nbsp; {{ save }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BootstrapTable from '@/components/BootstrapTable.vue'
import PageDetail from '@/components/PageDetail.vue'
import FroalaEditor from "@/components/FroalaEditor.vue";

export default {
  name: 'adminTemplateEditor',
  components: {
    BootstrapTable,
    PageDetail,
    FroalaEditor
  },
  data () {
    return {
      add: dictionaryHelpers.getDictionary('Add'),
      admin: dictionaryHelpers.getDictionary('Admin'),
      cancel: dictionaryHelpers.getDictionary('Cancel'),
      del: dictionaryHelpers.getDictionary('Delete'),
      deleteCompleted: dictionaryHelpers.getDictionary('DeleteCompleted'),
      detailTemplateEditorConfiguration: [],
      detailTemplateEditorData: {},
      disableButton: true,
      insertCompleted: dictionaryHelpers.getDictionary('InsertCompleted'),
      newTemplateEditor: dictionaryHelpers.getDictionary('NewTemplateEditor'),
      openDetail: dictionaryHelpers.getDictionary('OpenDetail'),
      tableTemplateEditorConfiguration: [],
      tableTemplateEditorData: [],
      tableTemplateEditorResult: [],
      templateEditor: dictionaryHelpers.getDictionary('TemplateEditor'),
      rowsSelected: 0,
      rowIdSelected: 0,
      save: dictionaryHelpers.getDictionary('Save'),
      setting: dictionaryHelpers.getDictionary('Setting'),
      updateCompleted: dictionaryHelpers.getDictionary('UpdateCompleted'),
      url: window.location.pathname,
      tipoTemplate: "Pages"
    }
  },
  created () {
    spinnerHelpers.show()
    var templateEditor = this
    adminConfigurationServices.getFunctionality(function (result) {
      templateEditor.detailTemplateEditorConfiguration = result.data.tabsConfigurations[0].pageConfigurations
      templateEditor.tableTemplateEditorConfiguration = result.data.tablesConfigurations[0].tablesConfigurations
      templateEditor.loadTemplateEditorTable();
    })
  },
  methods: {
    loadTemplateEditorTable () {
      var adminTemplateEditor = this

      templateEditorServices.getDto(function (result) {
        adminTemplateEditor.tableTemplateEditorData = result.data
        spinnerHelpers.hide()
      })
    },

    updateContenuto(value) {

      this.detailTemplateEditorData.html = value;
    },

    templateEditorFormatter (value, row, index, field) {
      var adminTemplateEditor = this
      var html = '<div class="container-fluid nopadding" style="width:80px;"><div class="row">'
        html += 
        '<button class="btn btn-success" onclick="adminTemplateEditor.__vue__.executeOpenDetail(' +
        row.id +
        ')"><i class="fa fa-pencil" title="' +
        this.openDetail +
        '" /></button>';
        html += 
        '<button class="btn btn-info" onclick="adminTemplateEditor.__vue__.clone(' +
        row.id +
        ')"><i class="fa fa-files-o"/></button>';

      if (functionHelpers.isValued(this.tableTemplateEditorResult)) {
        $.each(this.tableTemplateEditorResult, function (i, result) {
          if (result.id == row.id) {
            if (result.success) {
              html +=
                '<div class="col-1"><i class="fa fa-check text-success" title="'
              if (functionHelpers.isValued(result.message)) {
                html += result.message
              } else {
                html += adminTemplateEditor.updateCompleted
              }
              html += '" /></div>'
            } else {
              html +=
                '<div class="col-1"><i class="fa fa-exclamation-triangle text-danger" title="' +
                result.message +
                '" /></div>'
            }
          }
        })
        return html
      }
      html += '</div></div>'
    },
    clone(id){
      spinnerHelpers.show();
      var templateEditor = this;

      templateEditorServices.clone(id, function(result) {
        templateEditor.loadTemplateEditorTable();
        notificationHelpers.success(dictionaryHelpers.getDictionary("CloneCompleted"));
      });

      spinnerHelpers.hide();
    },
    executeOpenDetail (id) {
      spinnerHelpers.show()
      var templateEditor = this
      this.rowIdSelected = id

      $.each(this.tableTemplateEditorData, function (i, row) {
        if (templateEditor.rowIdSelected == row.id) {
          templateEditor.detailTemplateEditorData = row
        }
      })

      $('#tabTemplateEditorTable').removeClass('active')
      $('#tabTemplateEditorDetail').addClass('active')
      spinnerHelpers.hide()
    },

    onNewTemplateEditor () {
      spinnerHelpers.show()
      this.detailTemplateEditorData = {};
      this.rowIdSelected = 0;
      this.detailTemplateEditorData.id = "";
      this.detailTemplateEditorData.html = "";
      
      $('#tabTemplateEditorTable').removeClass('active')
      $('#tabTemplateEditorDetail').addClass('active')
      spinnerHelpers.hide()
    },

    confirmSaveTemplateEditor () {
      if (confirm(dictionaryHelpers.getDictionary('ConfirmSave'))) {
        this.executeSaveTemplateEditor()
      }
    },

    executeSaveTemplateEditor () {
      spinnerHelpers.show()
      var templateEditor = this
      this.rowsSelected = 0
      this.tableTemplateEditorResult = []

      $.each(this.$refs.tableTemplateEditor.getRowSelected(), function (i, row) {
        var rowToSave = row
        rowToSave.idFunctionality = menuHelpers.getIdFunctionByAdminUrl()
        templateEditor.rowsSelected = templateEditor.rowsSelected + 1

        templateEditorServices.updateTable(
          rowToSave,
          function () {
            templateEditor.checkAllIsSaved()
            templateEditor.tableTemplateEditorResult.push({
              id: rowToSave.id,
              success: true
            })
            notificationHelpers.success(templateEditor.updateCompleted)
          },
          function (response) {
            templateEditor.checkAllIsSaved()
            templateEditor.tableTemplateEditorResult.push({
              id: rowToSave.id,
              success: false,
              message: response
            })
            notificationHelpers.error(response)
          }
        )
      })
    },

    confirmDeleteTemplateEditor () {
      if (confirm(this.confirmDelete)) {
        this.executeDeleteTemplateEditor()
      }
    },

    executeDeleteTemplateEditor () {
      spinnerHelpers.show()
      var templateEditor = this
      this.rowsSelected = 0
      this.tableTemplateEditorResult = []

      $.each(this.$refs.tableTemplateEditor.getRowSelected(), function (i, row) {
        templateEditor.rowsSelected = templateEditor.rowsSelected + 1

        templateEditorServices.del(
          row.id,
          function () {
            templateEditor.checkAllIsSaved()
            notificationHelpers.success(templateEditor.deleteCompleted)
          },
          function (response) {
            templateEditor.checkAllIsSaved()
            templateEditor.tableTemplateEditorResult.push({
              id: rowToSave.id,
              success: false,
              message: response
            })
            notificationHelpers.error(response)
          }
        )
      })
    },

    onTableCheckTemplateEditor () {
      var countRowSelected = this.$refs.tableTemplateEditor.countRowSelected()
      if (countRowSelected == 0) {
        this.disableButton = true
      } else {
        this.disableButton = false
      }
    },

    confirmCancelNewTemplateEditor () {
      if (confirm(dictionaryHelpers.getDictionary('ConfirmCancel'))) {
        this.executeCancelNewTemplateEditor()
      }
    },

    executeCancelNewTemplateEditor () {
      spinnerHelpers.show()
      this.detailTemplateEditorData = {};
      this.rowIdSelected = 0;
      this.detailTemplateEditorData.id = "";
      this.detailTemplateEditorData.html = "";
      $('#tabTemplateEditorTable').addClass('active')
      $('#tabTemplateEditorDetail').removeClass('active')
      spinnerHelpers.hide()
    },

    confirmSaveNewTemplateEditor () {
      if (confirm(dictionaryHelpers.getDictionary('ConfirmSave'))) {
        this.executeSaveNewTemplateEditor()
      }
    },

    executeSaveNewTemplateEditor () {
      spinnerHelpers.show()
      var templateEditor = this
      this.detailTemplateEditorData.idFunctionality = menuHelpers.getIdFunctionByAdminUrl()

      if (
        functionHelpers.isValued(this.rowIdSelected) &&
        this.rowIdSelected > 0
      ) {
        this.detailTemplateEditorData.id = this.rowIdSelected

        templateEditorServices.update(this.detailTemplateEditorData, function (
          result
        ) {
          templateEditor.tableTemplateEditorResult.push({
            id: result.data,
            success: true,
            message: templateEditor.updateCompleted
          })
          notificationHelpers.success(templateEditor.updateCompleted)
          templateEditor.loadTemplateEditorTable();
          templateEditor.detailTemplateEditorData = {};
          templateEditor.detailTemplateEditorData.html = "";
          $('#tabTemplateEditorTable').addClass('active')
          $('#tabTemplateEditorDetail').removeClass('active')
        })
      } else {
        templateEditorServices.insert(this.detailTemplateEditorData, function (
          result
        ) {
          templateEditor.tableTemplateEditorResult.push({
            id: result.data,
            success: true,
            message: templateEditor.insertCompleted
          })
          templateEditor.detailTemplateEditorData = {};
          templateEditor.detailTemplateEditorData.html = "";
          notificationHelpers.success(templateEditor.insertCompleted)
          templateEditor.loadTemplateEditorTable()
          $('#tabTemplateEditorTable').addClass('active')
          $('#tabTemplateEditorDetail').removeClass('active')
        })
      }
    },

    checkAllIsSaved () {
      this.rowsSelected = this.rowsSelected - 1
      if (this.rowsSelected == 0) {
        this.disableButton = true
        this.loadTemplateEditorTable()
      }
    }
  }
}
</script>

<style>
.btn-ghost-dark:hover {
  color: #2f353a;
  background-color: transparent;
  background-image: none;
  border-color: transparent;
}

img {
  height: 100px;
}


.card-title-admin h1{
  font-size:40px;
  font-weight: lighter;
  color:#303C54;
}
.align-btns {
    position: absolute;
    z-index: 1;
    margin-top: 10px;
}
#idTemplateEditorGroup + .select2 {
    height: 56px;
    float: left;
    padding-top: 10px;
}

#select2-idTemplateEditorGroup-container{
    font-size: 16px;
    font-family: inherit;
    color: #5c6873;
    margin-top: 10px;
}

.select2-container--default .select2-selection--single .select2-selection__arrow {
    height: 26px;
    position: absolute;
    top: 7px!important;
    right: 1px;
    width: 20px;
    margin-top: 3px;
}


</style>


